import { Button, ButtonTypes, Dialog as SharedDialog, DialogContent, DialogHeader, DialogTitle } from "@repo/ui";
import { X } from "lucide-react";
import { useRef, type ReactNode } from "react";

import styles from "./style.module.scss";

export function Dialog({
	title,
	children,
	onClose,
	busy = false,
}: {
	title: string;
	children: ReactNode;
	onClose: () => void;
	busy?: boolean;
}) {
	const previous = useRef(document.activeElement as HTMLElement | null);
	return (
		<SharedDialog
			open
			onOpenChange={(open) => {
				if (!open && !busy) onClose();
			}}
		>
			<DialogContent
				className={styles.dialog}
				showCloseButton={false}
				aria-describedby={undefined}
				onInteractOutside={(event) => event.preventDefault()}
				onEscapeKeyDown={(event) => {
					if (busy) event.preventDefault();
				}}
				onCloseAutoFocus={(event) => {
					event.preventDefault();
					previous.current?.focus();
				}}
			>
				<DialogHeader className={styles.dialogHeader}>
					<DialogTitle>{title}</DialogTitle>
					<Button types={[ButtonTypes.Icon]} aria-label="Close dialog" disabled={busy} onClick={onClose}>
						<X size={20} />
					</Button>
				</DialogHeader>
				{children}
			</DialogContent>
		</SharedDialog>
	);
}
